import React from "react";
import { createStore } from "redux";
import { compose } from "recompose";
import { combineForms, Form } from "react-redux-form";
import { omit, isFunction } from "lodash";
import { connect } from "react-redux";

export const withLocalForm = ({
  initialState = {},
  model = "local",
  stateKey = "state",
  formKey = null,
  dispatchKey = "dispatch",
  storeKey = "store",
  localFormKey = "LocalForm",
} = {}) =>
  compose(
    (BaseComponent) =>
      class LocalForm extends React.Component {
        constructor(props) {
          super(props);

          this.store =
            props.store ||
            createStore(
              combineForms({
                [model]: isFunction(initialState)
                  ? initialState(props)
                  : initialState,
              })
            );

          this.dispatch = (action) => {
            if (typeof action === "function") {
              return action(this.store.dispatch, this.store.getState);
            }

            return this.store.dispatch(action);
          };
        }

        renderLocalForm = (props) => {
          const allowedProps = omit(props, ["store"]);
          return <Form store={this.store} model={model} {...allowedProps} />;
        };

        render = () => {
          const props = {
            [localFormKey]: this.renderLocalForm,
            [storeKey]: this.store,
            [dispatchKey]: this.dispatch,
          };

          return <BaseComponent {...this.props} {...props} />;
        };
      },
    connect(
      (state) => {
        const result = {
          [stateKey]: state[model],
        };

        if (formKey) {
          result[formKey] = state.forms[model];
        }

        return result;
      },
      (dispatch, ownProps) => ({ [dispatchKey]: ownProps[dispatchKey] }),
      null,
      { storeKey }
    )
  );

export default withLocalForm;
